// removed by extract-text-webpack-plugin
module.exports = {"with-ellipsis":"containers_with-ellipsis---sb","withEllipsis":"containers_with-ellipsis---sb","app":"containers_app---sb","segment":"containers_segment---sb","full-height":"containers_full-height---sb","fullHeight":"containers_full-height---sb","static-cart-wrapper":"containers_static-cart-wrapper---sb","staticCartWrapper":"containers_static-cart-wrapper---sb","rtl":"containers_rtl---sb","mobile":"containers_mobile---sb","toastr":"containers_toastr---sb"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/styles.less
// module id = 1936
// module chunks = 0